import { render } from "./ServiceItsCardEliteComp.vue?vue&type=template&id=68321fc2&scoped=true"
import script from "./ServiceItsCardEliteComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsCardEliteComp.vue?vue&type=script&lang=js"

import "./ServiceItsCardEliteComp.vue?vue&type=style&index=0&id=68321fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68321fc2"]])

export default __exports__